import clsx from "clsx"
import { forwardRef, HTMLProps } from "react"

// import { ReactComponent as CheckIcon } from "../../icons/src/ui/check.svg"
import cls from "./Checkbox.module.scss"

type CheckboxProps = {
  wrapperClassName?: string
  checkboxClassName?: string
} & HTMLProps<HTMLInputElement>

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ id, children, className, wrapperClassName, checkboxClassName, ...props }, ref) => {
    return (
      <div className={clsx(cls.wrapper, wrapperClassName)}>
        <input ref={ref} id={id} className={cls.input} type="checkbox" {...props} />

        <label htmlFor={id} className={clsx(cls.label, className)}>
          <div className={clsx(cls.checkbox, checkboxClassName)}>
            <CheckIcon className={cls.icon} />
          </div>

          {children && <div>{children}</div>}
        </label>
      </div>
    )
  }
)

const CheckIcon = ({ ...props }: { className?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20" {...props}>
      <g clipPath="url(#clip0)">
        <path d="M7.658 17.471a1.018 1.018 0 01-1.444 0L.45 11.705a1.531 1.531 0 010-2.166l.722-.722a1.531 1.531 0 012.166 0l3.6 3.6 9.726-9.727a1.531 1.531 0 012.166 0l.722.722a1.531 1.531 0 010 2.166L7.658 17.47z" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
